// @ts-nocheck
// TODO: tighten types after migration
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useRegion } from '../context/RegionContext';
import './RegionPopup.css';

const RegionPopup = () => {
    const location = useLocation();
    const { showPopup, detectedCountry, selectedCountry, confirmRegion, regions } = useRegion();
    const [tempSelected, setTempSelected] = useState('IN');

    useEffect(() => {
        if (showPopup) {
            setTempSelected(selectedCountry || detectedCountry || 'IN');
        }
    }, [showPopup, selectedCountry, detectedCountry]);

    // Only show on store-related pages
    const isStorePage = location.pathname === '/store' ||
                        location.pathname.startsWith('/store/') ||
                        location.pathname === '/checkout';

    if (!isStorePage || !showPopup) return null;

    return (
        <div className="region-popup-overlay fixed top-0 left-0 right-0 bottom-0 bg-black bg-opacity-60 flex justify-center items-center z-[10000]">
            <div className="region-popup-content bg-white p-6 rounded-[12px] shadow-[0_4px_6px_rgba(0,0,0,0.1)] max-w-[400px] w-[90%]">
                <h3 className="mt-0 text-[1.25rem] font-semibold text-[#1a1a1a] mb-3">Select Your Region</h3>
                <p className="text-[0.95rem] text-[#4b5563] mb-4 leading-relaxed">
                    We detected you are visiting from <strong>{detectedCountry}</strong>.
                </p>
                <p className="text-[0.95rem] text-[#4b5563] mb-4 leading-relaxed">Please confirm your country to see accurate pricing and shipping options.</p>

                <select
                    value={tempSelected}
                    onChange={(e) => setTempSelected(e.target.value)}
                    className="region-select w-full p-[10px] border border-[#d1d5db] rounded-[6px] bg-white text-base text-[#1f2937] mb-5"
                >
                    {regions && regions.length > 0 ? (
                        regions.map((region) => (
                            <option key={region.country} value={region.country}>
                                {region.name || region.country}
                            </option>
                        ))
                    ) : (
                        <>
                            <option value="IN">India (IN)</option>
                            <option value="US">United States (US)</option>
                        </>
                    )}
                </select>

                <div className="region-popup-actions flex justify-end">
                    <button onClick={() => confirmRegion(tempSelected)} className="confirm-btn bg-[#2563eb] text-white border-none px-5 py-[10px] rounded-[6px] font-semibold cursor-pointer transition-colors duration-200 hover:bg-[#1d4ed8]">
                        Confirm & Continue
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RegionPopup;
